module.exports = __webpack_public_path__ + "media/images/contentm-99060c79c4a2f8fdc3c15014f2bfa96f.svg";